module.exports = __webpack_public_path__ + "img/shoes.8c7722ee.png";